module.exports = __webpack_public_path__ + "static/media/ic-project-management-support.4db26f7a.svg";